export const tableOption = {
  border: true,
  // index: true,
  // indexLabel: '序号',
  delBtn:false,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  refreshBtn: true,
  searchMenuSpan: 6,
  showClomnuBtn: false,
  searchSize: 'mini',
  menu:false,
  addBtn: false,
  editBtn: true,
  viewBtn: false,
  // selection: true,
  reserveSelection:true,
  props: {
    label: 'label',
    value: 'value'
  },
  column: [{
    label: '来源ID',
    labelWidth: 100,
    width: 300,
    prop: 'sourceId',
    slot:true,
    row: true,
    editDisabled:true,
    span: 24
  }, {
    label: '轻任务订单号',
    labelWidth: 110,
    width: 200,
    searchslot:true,
    prop: 'orderId',
    searchLabelWidth: 110,
    row: true,
    editDisplay: false,
    span: 24
  }, {
    label: '客户名称',
    prop: 'custName',
    editDisplay: false,
    row: true,
  }, {
    label: 'PM',
    editDisplay: false,
    prop: 'pmName',
    labelWidth: 110,
    row: true,
    formslot: true
  }, {
    label: '当前任务',
    editDisplay: false,
    prop: 'flowName',
    row: true,
  }, {
    label: '语种',
    editDisplay: false,
    prop: 'slan',
    row: true,
  }, {
    label: '任务截止时间',
    sortable:true,
    editDisplay: false,
    prop: 'limitTime',
    row: true,
  }, {
    label: '剩余包数',
    editDisplay: false,
    prop: 'remainPackageNum',
    row: true,
  }, {
    label: '审批状态',
    editDisplay: false,
    type: 'select',
    dicData: [],
    prop: 'projectStaus',
    row: true,
  },{
    label: '风险等级',
    sortable:true,
    editDisplay: false,
    row: true,
    prop: 'riskLevel'
  },{
    label: '',
    editDisplay: false,
    prop: 'tlan',
    row: true,
    hide:true
  }]
}
